
// FAQ dropdown
$('.ordering .panel-heading, .shipping .panel-heading').on("click", function(){
	  $(this).next().slideToggle();
	  $(this).parent().toggleClass('active');
	});

// BOOTSTRAP //
jQuery(document).ready(function(jQuery){
	$(".single-option-selector").css("width","100%");
	$('.typeahead').typeahead();
	$('.dropdown-toggle').dropdown();
	$('.carousel').carousel({
		interval: 10000
	})
});

// PLACEHOLDER POLYFILL //
$(document).ready(function(){
  
    $(".show-sidebar").on('click', function(){
		$("#sidebar").toggleClass('hidden-tablet');
		$("#sidebar").toggleClass('hidden-phone');
    });
  
	function add() {
		if($(this).val() == ''){
			$(this).val($(this).attr('placeholder')).addClass('placeholder');
		}
	}

	function remove() {
		if($(this).val() == $(this).attr('placeholder')){
			$(this).val('').removeClass('placeholder');
		}
	}

	// Create a dummy element for feature detection
	if (!('placeholder' in $('<input>')[0])) {

		// Select the elements that have a placeholder attribute
		$('input[placeholder], textarea[placeholder]').blur(add).focus(remove).each(add);

		// Remove the placeholder text before the form is submitted
		$('form').submit(function(){
			$(this).find('input[placeholder], textarea[placeholder]').each(remove);
		});
	}
});

// CURRENCY SELECTOR //
$('.selected-currency a').click(function() {
	$('.selected-currency a').hide();
	$('#currencies-picker').fadeIn();
	return false;
});
$('#currencies-picker select').change(function() {
	$('#currencies-picker').hide();
	$('.selected-currency a').fadeIn();
	return true;
}).blur(function() {
	$('#currencies-picker').hide();
	$('.selected-currency a').fadeIn();
	return true;
})

$(window).scroll(function(){
  if( $(window).width() > 768 ) {
    if( $(window).scrollTop() > 108 ) { 
      $('.navbar-fixed-top').css({'position': 'fixed', 'padding': '0'});
      $('#page_header').css('margin-bottom', '102px');
    }
    else {
      $('.navbar-fixed-top').css({'position': 'relative', 'padding': '0'});
      $('#page_header').css('margin-bottom', '0');
    }
  }
  else if( $(window).width() > 600 ) {
    if( $(window).scrollTop() > 173 ) { 
      $('.navbar-fixed-top').css({'position': 'fixed', 'padding': '0 20px'});
      $('#page_header').css('margin-bottom', '102px');
    }
    else {
      $('.navbar-fixed-top').css({'position': 'relative', 'padding': '0'});
      $('#page_header').css('margin-bottom', '0');
    }
  }
  else {
    if( $(window).scrollTop() > 238 ) { 
      $('.navbar-fixed-top').css({'position': 'fixed', 'padding': '0 20px'});
      $('#page_header').css('margin-bottom', '102px');
    }
    else {
      $('.navbar-fixed-top').css({'position': 'relative', 'padding': '0'});
      $('#page_header').css('margin-bottom', '0');
    }
  }
});